module.exports = __webpack_public_path__ + "img/bg_2.ba4617cd.png";